
import { throwError as observableThrowError, Observable, BehaviorSubject } from 'rxjs';
import { Injectable, Renderer2 } from '@angular/core';
import { ManagePaymentRequest } from '@features/account/models/manage-payment.model';
import { ProxyService } from '@core/services/proxy.service';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { AlertService } from '@core/services/alert.service';
import { EncryptedCardData, EncryptionMode, PaymentCardType2, PaymentMethodRequest, PaymentServiceProvider, PaymentPayloadResponse, PaymentType, PaymentTypeString } from '@app/core/models/payment-service-models.model';
import { environment } from '@environments/environment';
import { CreditCard } from 'angular-cc-library';
import { GtmExternal, PaymentCTAEvent, PaymentTypeGTM } from '@app/shared/models/configs/gtm.external';
import { CheckTimeUtility } from '@app/features/ordering/utilties/check-time-utility';


declare function ValidatePANChecksum(a, b, c): any;
declare function ProtectPANandCVV(a, b, c): any;
declare const PIE: any;
@Injectable()
export class ManagePaymentService {
    constructor(private proxy: ProxyService, private alertService: AlertService) { }

    private cardList: any;
    private getCardDeatilsResponse: any;
    private cardListSource = new BehaviorSubject<Array<ManagePaymentRequest>>(new Array<ManagePaymentRequest>());

    currentList = this.cardListSource.asObservable();
    selectedCard: ManagePaymentRequest;
    
    getGTMCTAEvent(paymentProvider: PaymentServiceProvider, brandName: string) {
        const gtmCTAEvent = new PaymentCTAEvent();
        gtmCTAEvent.event = GtmExternal.EVENT_CTA_CLICK;
        gtmCTAEvent.click_text = 'Continue';
        gtmCTAEvent.payment_system = paymentProvider === PaymentServiceProvider.Chase ? PaymentTypeGTM.Chase : (paymentProvider === PaymentServiceProvider.Stripe ? PaymentTypeGTM.Stripe : null);
        gtmCTAEvent.payment_type = 'Credit/Debit Card ' + this.capitalizeFirstChar(brandName);
        return gtmCTAEvent;
    }
    updateChange(cardList: Array<ManagePaymentRequest>) {
        this.cardListSource.next(cardList);
    }

    clearList() {
        this.cardList = [];
        this.updateChange(this.cardList);
    }
    filterPaymentTypes(paymentTypes: any) {
        if(!paymentTypes) return [];
        if(environment.DISABLE_PAYPAL) {
            paymentTypes = paymentTypes.filter(cc => cc.paymentType?.toLowerCase() !== PaymentTypeString.Paypal);
        }
        paymentTypes = paymentTypes.filter(cc => cc.paymentType?.toLowerCase() !== PaymentTypeString.GiftCardPay);
        if(!paymentTypes?.some(cc => cc?.paymentType?.toLowerCase() === PaymentTypeString.Paypal) && !environment.DISABLE_PAYPAL) {
            paymentTypes.push({paymentMethodType: 3, paymentType: PaymentTypeString.Paypal})
        } 
        return paymentTypes;
    }
    getCarddetails(isPayPalreq: boolean = false) {
        this.cardList = new Array<ManagePaymentRequest>();
        this.proxy.httpGet(ApiRoutes.PAYMENT_METHODS).subscribe(
            (success) => {
                let response = <any>success.body.valueOf();
                this.getCardDeatilsResponse = this.filterPaymentTypes(response);
                for (const details of this.getCardDeatilsResponse) {
                    const cdDetails = new ManagePaymentRequest();
                    if (details.paymentType === PaymentTypeString.Card) {
                        cdDetails.brand = details.cardInfo.brand ? details.cardInfo.brand.toLowerCase() : PaymentCardType2[details.cardInfo.cardBrand];
                        cdDetails.expirationMonth = parseInt(details.cardInfo.expirationMonth, 10);
                        cdDetails.expirationYear = parseInt(details.cardInfo.expirationYear, 10);
                        cdDetails.id = details.cardInfo.id;
                        cdDetails.name = details.cardInfo.name;
                        cdDetails.number = details.cardInfo.number;
                        cdDetails.zipCode = details.cardInfo.zipCode;
                        cdDetails.isExpired = CheckTimeUtility.isCardExpired(cdDetails.expirationMonth, cdDetails.expirationYear);
                    }
                    cdDetails.isDefault = (details.hasOwnProperty('isDefault')) ? details.isDefault : false;
                    cdDetails.paymentType = details.paymentType;
                    cdDetails.isAutoReload = details.isAutoReload;
                    if (details.paymentType === 'card') {
                        cdDetails.paymentServiceProvider = details?.cardInfo.paymentServiceProvider;
                    }
                    if (!isPayPalreq) {
                        if (details.paymentType.toLowerCase() !== 'paypal') {
                            this.cardList.push(cdDetails);
                        }
                    } else {
                        this.cardList.push(cdDetails);

                    }
                }

                this.updateChange(this.cardList);
            },
            (err) => {
                // this.cardList = null;
                this.cardList = [];
                this.updateChange(this.cardList);
                this.alertService.error(err.error.message);
            }
        );
    }

    refreshPaymentMethods(isPayPalreq: boolean = false) {
        this.cardList = new Array<ManagePaymentRequest>();
        return this.proxy.httpGet(ApiRoutes.PAYMENT_METHODS).toPromise().then(
            (success) => {
                let response = <any>success.body.valueOf();
                this.getCardDeatilsResponse = this.filterPaymentTypes(response);
                this.cardList = new Array<ManagePaymentRequest>();
                for (const details of this.getCardDeatilsResponse) {
                    const cdDetails = new ManagePaymentRequest();
                    if (details.paymentType === PaymentTypeString.Card) {
                        cdDetails.brand = details.cardInfo.brand ? details.cardInfo.brand.toLowerCase() : PaymentCardType2[details.cardInfo.cardBrand];
                        cdDetails.expirationMonth = parseInt(details.cardInfo.expirationMonth, 10);
                        cdDetails.expirationYear = parseInt(details.cardInfo.expirationYear, 10);
                        cdDetails.id = details.cardInfo.id;
                        cdDetails.name = details.cardInfo.name;
                        cdDetails.number = details.cardInfo.number;
                        cdDetails.zipCode = details.cardInfo.zipCode;
                        cdDetails.isExpired = CheckTimeUtility.isCardExpired(cdDetails.expirationMonth, cdDetails.expirationYear);
                    }
                    cdDetails.isDefault = (details.hasOwnProperty('isDefault')) ? details.isDefault : false;
                    cdDetails.paymentType = details.paymentType;
                    cdDetails.isAutoReload = details.isAutoReload;
                    if (details.paymentType === 'card') {
                        cdDetails.paymentServiceProvider = details?.cardInfo.paymentServiceProvider;
                    }
                    if (!isPayPalreq) {
                        if (details.paymentType.toLowerCase() !== 'paypal') {
                            this.cardList.push(cdDetails);
                        }
                    } else {
                        this.cardList.push(cdDetails);

                    }
                }

                this.updateChange(this.cardList);
            },
            (err) => {                
                this.cardList = [];
                this.updateChange(this.cardList);
                this.alertService.error(err.error.message);
            }
        ).catch(error => {
            this.cardList = [];
            this.updateChange(this.cardList);
            this.alertService.error(error?.error?.message);
        });
    }
    getCardList(): (Promise<ManagePaymentRequest[]> | any) {
        return this.proxy.httpGet(ApiRoutes.PAYMENT_METHODS).toPromise().then
            ((success) => {
                let body = <ManagePaymentRequest[]>success.body.valueOf();
                body = this.filterPaymentTypes(body);
                return body;
            }).catch((err) => {
                return observableThrowError(err);
            });
    }
    createEncryptedCardData(encryptedCardData: EncryptedCardData, chaseResult: any, mode: EncryptionMode, PIE: any) {
        encryptedCardData =
        {
            encryptedCardNumber: chaseResult[0],
            encryptedCVV: chaseResult[1],
            integrityCheckValue: chaseResult[2],
            keyId: PIE.key_id,
            phase: PIE.phase,
            mode: mode,
            format: environment.chaseConfig.formatPreserveFirst6Last4
        };
        return encryptedCardData;
    }
    createChasePayload(cardBrand: string, xCoord: string, cardNo: any, chaseResult: any, set_default_payment: any, encryptedCardData: EncryptedCardData, addressValue: any, cardExpiry: any) {

        const cardLast4 = chaseResult[0]?.substring(chaseResult[0].length - 4);
        const payload: PaymentMethodRequest = {
            isDefault: set_default_payment,
            isAutoReload: false,
            paymentType: PaymentTypeString.Card,
            // 'token': result.token.id          
            paymentToken: {
                chaseEncryptedCardData: encryptedCardData,
                cardLastFour: cardLast4,
                paymentType: PaymentType.Card,
                paymentServiceProvider: PaymentServiceProvider.Chase,
                cardBrand: PaymentCardType2[cardBrand] ?? PaymentCardType2.Unknown,
                cardInfo: {
                    id: encryptedCardData.encryptedCardNumber,
                    name: addressValue.name,
                    number: cardLast4,
                    expirationYear: cardExpiry.substring(cardExpiry.length - 2),
                    expirationMonth: cardExpiry.substring(0, 2),
                    zipCode: addressValue.address_zip,
                    paymentServiceProvider: PaymentServiceProvider.Chase,
                    brand: cardBrand,
                    cardBrand: PaymentCardType2[cardBrand] ?? PaymentCardType2.Unknown
                    // cardBrand:0,
                    // fingerprint: null,
                    // tokenizationType: null
                }
            },
        };
        if (xCoord) {
            payload['x-coordinates'] = xCoord;
        }
        return payload;
    }
    loadScript(renderer: Renderer2, src: string) {
        const script = renderer.createElement('script');
        script.src = src;
        renderer.appendChild(document.head, script);
    }
    getCardTypeClass(cardDetail: any, cardStyle: string) {
        if (cardDetail.paymentType === PaymentTypeString.Card) {
            if (cardDetail.brand) {
                switch (cardDetail.brand.toLowerCase()) {
                    case 'visa': {
                        cardStyle = cardStyle + ' btn-visa-card';
                        break;
                    }
                    case 'mastercard': {
                        cardStyle = cardStyle + ' btn-master-card';
                        break;
                    }
                    case 'american express': {
                        cardStyle = cardStyle + ' btn-amex-card';
                        break;
                    }
                    case 'amex': {
                        cardStyle = cardStyle + ' btn-amex-card';
                        break;
                    }
                    case 'diners club': {
                        cardStyle = cardStyle + ' btn-dinersclub-card';
                        break;
                    }
                    case 'jcb': {
                        cardStyle = cardStyle + ' btn-jcb-card';
                        break;
                    }
                    case 'unionpay': {
                        cardStyle = cardStyle + ' btn-unionpay-card';
                        break;
                    }
                    case 'discover': {
                        cardStyle = cardStyle + ' btn-discover-card';
                        break;
                    }
                    default: {
                        cardStyle = cardStyle + ' btn-visa-card';
                        break;
                    }
                }
            } else {
                cardStyle = cardStyle + 'btn-visa-card';
            }

        } else if (cardDetail.paymentType === 'paypal') {
            cardStyle = cardStyle + ' btn-paypal-card';
        }
        return cardStyle;
    }

    getPaymentPayload(paymentProvider: PaymentServiceProvider, params: any): PaymentPayloadResponse {
        if (paymentProvider === PaymentServiceProvider.Stripe) {
            const payload: PaymentMethodRequest = {
                isDefault: params.set_default_payment,
                isAutoReload: false,
                paymentType: PaymentTypeString.Card,
                token: params.tokenId
            };
            const payloadResponse: PaymentPayloadResponse = {
                paymentMethodRequest: payload,
                canEncryptCard: false
            }
            return payloadResponse;
        } else if (paymentProvider === PaymentServiceProvider.Chase) {
            const validateDetails = ValidatePANChecksum(params.cardNo, params.cardCvv, true);
            let chaseResult = null;
            let encryptedCardData: EncryptedCardData = null;
            if (validateDetails) {
                const mode = EncryptionMode.eFPE;
                const useFPEMode = false;
                chaseResult = ProtectPANandCVV(params.cardNo, params.cardCvv, useFPEMode);
                encryptedCardData = this.createEncryptedCardData(encryptedCardData, chaseResult, mode, PIE);
            } else {
                const payloadResponse: PaymentPayloadResponse = {
                    paymentMethodRequest: null,
                    canEncryptCard: false
                }
                return payloadResponse;
            }
            if (validateDetails && chaseResult) {
                const cardBrand = CreditCard.cardType(params.cardNo);
                const payload: PaymentMethodRequest = this.createChasePayload(cardBrand, null, params.cardNo, chaseResult, params.set_default_payment, encryptedCardData, params.addressValue, params.cardExpiry);
                const payloadResponse: PaymentPayloadResponse = {
                    paymentMethodRequest: payload,
                    canEncryptCard: true
                }
                return payloadResponse;
            } else {
                const payloadResponse: PaymentPayloadResponse = {
                    paymentMethodRequest: null,
                    canEncryptCard: false
                }
                return payloadResponse;
            }
        }
    }
    public capitalizeFirstChar(value: string): string{
        if (value) {
          return value.charAt(0).toUpperCase() + value.slice(1);    
        } return '';
    }
}

